import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SmartTableComponent } from './smart-table.component';
import { MaterialModule } from '@app/material.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [SmartTableComponent],
  imports: [CommonModule, MaterialModule, TranslateModule],
  exports: [SmartTableComponent]
})
export class SmartTableModule {}
